// extracted by mini-css-extract-plugin
module.exports = {"navItem":"styles-module--navItem--1y_O4","dashIcon":"styles-module--dashIcon--1ieC2"};